import "./combined_jquery"

import "../ss_foundation/app.js"
import "../vendor/placeholder.js"
import "../vendor/jquery.cookie.js"
import "handlebars/runtime"
import "@linkedin/rumjs"

import "../mobile/mobile_util.js"
import "../vendor/jquery.ba-postmessage.min.js"
import "../scribd/scribd_oauth.js"
import "../ss_foundation/global.js"
import "../ss_foundation/modernize.js"
import "../vendor/jquery.scrollTo-1.4.4.min.js"

window.ssClientUtils = require("@linkedin/slideshare-client-utils")
window.jSecure = require("@linkedin/jsecure")
window.loadCSS = require("fg-loadcss")
let { Intl, IntlPolyfill } = require("../dist/Intl.min.js")
window.Intl = Intl
window.IntlPolyfill = IntlPolyfill
window.t8 = require("../dist/t8.min.js")
require("../ss_foundation/app.js")
require("../dist/IntlLocaleData.min.js")
require("../dist/t8LocaleData.min.js")
require("../dist/xmessage-full.min.js")
require("../vendor/jquery.lazyload.js")
